module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background-shooting.64aef6c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background-shooting.jpg
// module id = 2820
// module chunks = 11